/**
 * @file
 * CTA Button component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 * @param {Function} once - The once function.
 */

(function (Drupal, once) {
  'use strict';

  let isKeyboardNavigation = false;

  /**
   * Temporarily disables transitions and re-enables them in the next frame.
   *
   * @param {HTMLElement} element - The element to disable transitions on.
   * @param {string} originalTransition - The original transition value.
   */
  function disableTransitionsTemporarily(element, originalTransition) {
    element.style.transition = 'none';
    requestAnimationFrame(function () {
      element.style.transition = originalTransition;
    });
  }

  /**
   * Behavior for CTA Button component.
   *
   * @type {object}
   */
  Drupal.behaviors.ctaButton = {
    attach: function (context, settings) {
      const buttons = once('cta-button', '.cta-button', context);

      // Track keyboard navigation
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          isKeyboardNavigation = true;
        }
      });

      document.addEventListener('mousedown', function () {
        isKeyboardNavigation = false;
      });

      buttons.forEach(function (button) {
        const originalTransition = window.getComputedStyle(button).transition;

        // Temporarily disable transitions when focused via keyboard
        button.addEventListener('focus', function () {
          if (isKeyboardNavigation) {
            disableTransitionsTemporarily(button, originalTransition);
          }
        });

        // Temporarily disable transitions when blurred via keyboard
        button.addEventListener('blur', function () {
          if (isKeyboardNavigation) {
            disableTransitionsTemporarily(button, originalTransition);
          }
        });
      });
    }
  };

})(Drupal, once);
